import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const clinicValues = ["Easy ordering of prescription pet food", "Fast deliveries straight to the door", "Quality-checked medicines and supplements"];
export default function OnlinePharmacyPortal() {
  return <section data-section-id="251567" id="online-pharmacy-portal" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="relative w-full">
            <div className="aspect-[4/3] md:aspect-square lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-lg bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_pharmacy_care.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_pharmacy_care.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_pharmacy_care.png-wvc-sizes" alt="Our well-stocked pharmacy for pets" className="w-full h-full object-cover" loading="lazy" />
            </div>
            {}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-accent/40 rounded-lg -z-10 blur-2xl"></div>
          </div>

          {}
          <div className="flex flex-col items-start">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
              Online Pharmacy & Pet Food Store
            </h2>
            
            <p className="text-lg md:text-xl font-medium text-ring mb-6">
              Convenient access to your pet’s health
            </p>
            
            <div className="space-y-4 text-muted-foreground mb-8 text-base md:text-lg leading-relaxed">
              <p>
                Our online pharmacy is designed to make life easier for you as a pet owner. Here you can easily renew prescriptions and order specialized diets recommended by our veterinarians.
              </p>
              <p>
                We combine medical expertise with modern technology to ensure your pet always has access to the right treatment and nutrition, no matter where you are.
              </p>
            </div>

            <ul className="space-y-4 mb-10 w-full">
              {clinicValues.map((value, index) => <li key={index} data-index={index} className="flex items-start gap-3 text-foreground">
                  <CircleCheck className="w-6 h-6 text-ring shrink-0 mt-0.5" aria-hidden="true" />
                  <span className="text-base md:text-lg font-medium font-default">{value}</span>
                </li>)}
            </ul>

            <Button asChild size="lg" className="rounded-lg px-8 text-base bg-ring hover:bg-ring/90 text-primary-foreground shadow-md transition-all hover:scale-105">
              <Link to="/EmergencyPharmacyPage">Visit Pharmacy</Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}